/**
 * Standard VGA 256-color palette (Mode 13h default)
 *
 * Colors 0-15: Standard 16 CGA colors
 * Colors 16-31: Grayscale ramp
 * Colors 32-255: Color cube with various intensities
 */

// Generate the standard VGA 256-color palette
function generateVGA256Palette(): [number, number, number][] {
  const palette: [number, number, number][] = [];

  // Colors 0-15: Standard CGA colors
  const cgaColors: [number, number, number][] = [
    [0x00, 0x00, 0x00], // 0  Black
    [0x00, 0x00, 0xAA], // 1  Blue
    [0x00, 0xAA, 0x00], // 2  Green
    [0x00, 0xAA, 0xAA], // 3  Cyan
    [0xAA, 0x00, 0x00], // 4  Red
    [0xAA, 0x00, 0xAA], // 5  Magenta
    [0xAA, 0x55, 0x00], // 6  Brown
    [0xAA, 0xAA, 0xAA], // 7  Light Gray
    [0x55, 0x55, 0x55], // 8  Dark Gray
    [0x55, 0x55, 0xFF], // 9  Light Blue
    [0x55, 0xFF, 0x55], // 10 Light Green
    [0x55, 0xFF, 0xFF], // 11 Light Cyan
    [0xFF, 0x55, 0x55], // 12 Light Red
    [0xFF, 0x55, 0xFF], // 13 Light Magenta
    [0xFF, 0xFF, 0x55], // 14 Yellow
    [0xFF, 0xFF, 0xFF], // 15 White
  ];
  palette.push(...cgaColors);

  // Colors 16-31: Grayscale ramp
  for (let i = 0; i < 16; i++) {
    const v = Math.round((i * 255) / 15);
    palette.push([v, v, v]);
  }

  // Colors 32-255: Color cube
  // Standard VGA uses a 6-level RGB cube (6x6x6 = 216 colors) plus extras
  // But the actual VGA palette is more complex - using the common approximation

  // Generate a 6x6x6 color cube (216 colors, indices 32-247)
  const levels = [0x00, 0x33, 0x66, 0x99, 0xCC, 0xFF];
  for (let r = 0; r < 6; r++) {
    for (let g = 0; g < 6; g++) {
      for (let b = 0; b < 6; b++) {
        palette.push([levels[r], levels[g], levels[b]]);
      }
    }
  }

  // Colors 248-255: Additional colors (fill remaining)
  // Extra saturated colors for variety
  const extras: [number, number, number][] = [
    [0xFF, 0x00, 0x00], // Bright red
    [0x00, 0xFF, 0x00], // Bright green
    [0x00, 0x00, 0xFF], // Bright blue
    [0xFF, 0xFF, 0x00], // Bright yellow
    [0xFF, 0x00, 0xFF], // Bright magenta
    [0x00, 0xFF, 0xFF], // Bright cyan
    [0x80, 0x80, 0x80], // Medium gray
    [0xC0, 0xC0, 0xC0], // Silver
  ];
  palette.push(...extras);

  return palette;
}

/** The 256-color VGA palette */
export const VGA_256_PALETTE: [number, number, number][] = generateVGA256Palette();

/** Export as a flat RGB array for WebGL/fast access */
export const VGA_256_PALETTE_FLAT: number[] = VGA_256_PALETTE.flat();
